/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCustomerPortalLinkRequest
 */
export interface ControlCustomerPortalLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCustomerPortalLinkRequest
     */
    return_url: string;
}

/**
 * Check if a given object implements the ControlCustomerPortalLinkRequest interface.
 */
export function instanceOfControlCustomerPortalLinkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "return_url" in value;

    return isInstance;
}

export function ControlCustomerPortalLinkRequestFromJSON(json: any): ControlCustomerPortalLinkRequest {
    return ControlCustomerPortalLinkRequestFromJSONTyped(json, false);
}

export function ControlCustomerPortalLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCustomerPortalLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'return_url': json['return_url'],
    };
}

export function ControlCustomerPortalLinkRequestToJSON(value?: ControlCustomerPortalLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'return_url': value.return_url,
    };
}

